import React from 'react';
import Navbar from '../../composants/site/Navbar';
import Hero from '../../composants/site/Hero';
import About from '../../composants/site/About';
import MeditationsSection from '../../composants/site/MeditationsSection';
import PartnersSection from '../../composants/site/PartnersSection';
import TestimonialsSection from '../../composants/site/TestimonialsSection';
import CommunitySection from '../../composants/site/CommunitySection';
import Footer from '../../composants/site/Footer';

function Accueil() {
    React.useEffect(() => {
        document.title = "LAMP | Accueil";
    }, []);

    return (
        <div className="site-wrapper">
            {/* Barre de navigation & Header */}
            <Navbar />

            <main>
                {/* 1. Accueil (Portail / Hero) */}
                <Hero />

                {/* 2. A propos — Contexte, Vision, Mission */}
                <About />

                {/* 3. Méditations (Carousel — 5 max) */}
                <MeditationsSection />

                {/* 4. Partenaires (Cartes) */}
                <PartnersSection />

                {/* 5. Témoignages */}
                <TestimonialsSection />

                {/* 6. Communauté */}
                <CommunitySection />
            </main>

            {/* Footer */}
            <Footer />

            <style>{`
                .site-wrapper {
                    background-color: #ffffff;
                    min-height: 100vh;
                    margin: 0 !important;
                    padding: 0 !important;
                }
                
                body {
                    margin: 0 !important;
                    padding: 0 !important;
                    overflow-x: hidden;
                    font-family: 'Inter', 'Outfit', sans-serif;
                }
                
                /* Transitions smooth entre sections */
                section {
                    position: relative;
                    z-index: 10;
                }
            `}</style>
        </div>
    );
}

export default Accueil;